// extracted by mini-css-extract-plugin
export default {"container":"ResourceLayout_container__nAQ0H","sidebar":"ResourceLayout_sidebar__94MGN","search":"ResourceLayout_search__IhP2i","children":"ResourceLayout_children__FGKtr"};